(function(){
  'use strict';

  // Scroll-driven card motion + parallax
  var cards = document.querySelectorAll('.card-section');
  if (cards.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) e.target.classList.add('in-view');
      });
    }, { threshold: 0.15 });
    cards.forEach(function(c){ io.observe(c); });
  }

  var lastY = window.scrollY;
  var scrollDir = 1;
  function onScroll() {
    var y = window.scrollY;
    scrollDir = y > lastY ? 1 : -1;
    lastY = y;
    var vh = window.innerHeight;
    cards.forEach(function(card){
      var r = card.getBoundingClientRect();
      var center = r.top + r.height / 2;
      var dist = (center - vh / 2) / vh;
      var scale = Math.max(0.94, 1 - Math.abs(dist) * 0.06);
      var translate = dist * 12;
      var rot = dist * -1.2;
      card.style.transform = 'translateY(' + translate + 'px) scale(' + scale + ') rotateX(' + rot + 'deg)';
      card.style.opacity = String(Math.max(0.55, 1 - Math.abs(dist) * 0.5));
    });
    var core = document.querySelector('.scene-core');
    if (core) {
      core.style.setProperty('--scroll-tilt', (scrollDir * 8) + 'deg');
      core.style.filter = 'blur(' + Math.min(y / 200, 2) + 'px)';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mouse-follow accent glow on cards
  cards.forEach(function(card){
    card.addEventListener('mousemove', function(e){
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  // Robot follows mouse pointer
  var robotStage = document.querySelector('.robot-stage');
  var robotHead = document.querySelector('.r-head');
  var targetTx = -6, targetTy = 0, targetHx = 0, targetHy = 0;
  var curTx = -6, curTy = 0, curHx = 0, curHy = 0;

  if (robotStage) {
    window.addEventListener('pointermove', function(e){
      var rect = robotStage.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var dx = Math.max(-1, Math.min(1, (e.clientX - cx) / (window.innerWidth * 0.45)));
      var dy = Math.max(-1, Math.min(1, (e.clientY - cy) / (window.innerHeight * 0.45)));
      targetTy = dx * 18;
      targetTx = -6 + dy * 6;
      targetHy = dx * 14;
      targetHx = -dy * 10;
    });

    (function anim(){
      curTx += (targetTx - curTx) * 0.08;
      curTy += (targetTy - curTy) * 0.08;
      curHx += (targetHx - curHx) * 0.12;
      curHy += (targetHy - curHy) * 0.12;
      robotStage.style.setProperty('--r-tx', curTx.toFixed(2) + 'deg');
      robotStage.style.setProperty('--r-ty', curTy.toFixed(2) + 'deg');
      if (robotHead) {
        robotHead.style.setProperty('--h-tx', curHx.toFixed(2) + 'deg');
        robotHead.style.setProperty('--h-ty', curHy.toFixed(2) + 'deg');
      }
      requestAnimationFrame(anim);
    })();
  }

  // Workflow animation - step highlighter
  var wfSteps = document.querySelectorAll('.wf-node');
  var wfLogs = document.querySelectorAll('.wf-log-line');
  if (wfSteps.length) {
    var wfStep = 0;
    function tickWorkflow() {
      wfSteps.forEach(function(n){ n.classList.toggle('active', +n.dataset.step === wfStep); });
      wfLogs.forEach(function(l, i){ l.classList.toggle('live', i <= wfStep); });
      wfStep = (wfStep + 1) % 7;
    }
    setInterval(tickWorkflow, 1200);
    tickWorkflow();
  }
})();
